export const REQUEST_ID_HEADER = 'X-Request-Id';

/** Correlation id sent with every request; the API echoes it and logs it. */
export function newRequestId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `req-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
